module.exports = __webpack_public_path__ + "img/finished.824ce0ea.svg";